// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';

import { localize } from '@ta/common.i18n';
import { Icon } from '@ta/styleguide.icon';

import styles from './POIObjectList.less';
import POIObject, { viewModelForObject } from './POIObject';

type Props = {
  pois: any[],
  limit: number,
  showSavesIcon: boolean,
};

type State = {
  showAll: boolean,
};

type InnerProps = {
  poi: any,
  showSavesIcon: boolean,
};

// Singular POI's have custom styling/locale
const SinglePOIObject = ({ poi, showSavesIcon }: InnerProps) => (
  <div className={`${styles.section} ${styles.poi}`}>
    <div className={styles.header}>
      {/* About this place */}
      {localize('about_this_place')}
    </div>
    <POIObject poi={viewModelForObject(poi)} showSavesIcon={showSavesIcon} />
  </div>
);

class POIObjectList extends React.Component<Props, State> {
  static defaultProps = {
    limit: 3,
    showSavesIcon: false,
  };
  constructor(props: Props) {
    super(props);
    this.state = { showAll: false };
  }
  showAllPOI = () => {
    this.setState({ showAll: true });
  };

  render() {
    const { pois, limit, showSavesIcon } = this.props;
    if (pois.length === 0) {
      return null;
    }
    // Ignore limit if length is 1, even if limit is 0
    if (pois.length === 1) {
      return <SinglePOIObject poi={pois[0]} showSavesIcon={showSavesIcon} />;
    }

    const lastIndex = this.state.showAll ? pois.length - 1 : limit - 1;
    const objects = (this.state.showAll ? pois : pois.slice(0, limit)).map((poi, index) => {
      let borderStyle = {};
      // Remove last border if showMore is not to be displayed
      if (index === lastIndex && (this.state.showAll || pois.length <= limit)) {
        borderStyle = { border: 'none' };
      }
      return (
        <div className={styles.multi_pois} key={poi.name}>
          <div className={styles.poi_padding} style={borderStyle}>
            <POIObject poi={viewModelForObject(poi)} notLazy showSavesIcon={showSavesIcon} />
          </div>
        </div>
      );
    });
    return (
      <div className={`${styles.section} ${styles.poi}`}>
        <div className={`${styles.header} ${styles.multi}`}>
          {/* About this place/these places */}
          {localize('social_About_this_place_plural', { '0': pois.length })}
        </div>
        {objects}
        {pois.length > limit && !this.state.showAll && (
          <div className={styles.show_more}>
            <span className="ui_link" onClick={this.showAllPOI}>
              {localize('airm_mobile_show_more')}
              <Icon name="caret-down" />
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default POIObjectList;
